import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui';
import { generateWithingsCodeRequestUrl } from './services/api';

type P = Record<string, unknown>;

const WithingsLoginButton: React.FC<P> = () => {
  const { t } = useTranslation();
  const withingsCodeRequestUrl = generateWithingsCodeRequestUrl();

  return (
    <Button item={{ href: withingsCodeRequestUrl, className: 'withings-button' }}>
      {t('Link with my Withings Account')}
    </Button>
  );
};

export default WithingsLoginButton;
